import { Box, Button, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import React, { useState } from "react";
import CustomTypography from "../../../../components/common/CustomTypography";
import { useOnboardingPromotionPage } from "../../../../hooks/useOnboardingPromotionPage";
import { usePromotionOnboardingTracking } from "../../../../hooks/usePromotionOnboardingTracking";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";

interface SelectOption {
  id: number;
  label: string;
}

export const selectOptionList: SelectOption[] = [
  { id: 1, label: "확실히 있다" },
  { id: 2, label: "어렴풋하게 있다" },
  { id: 3, label: "잘 모르겠다" },
];

export default function Motivation_14_V6({
  version = "v6",
}: {
  version?: MktVersionTypes;
}) {
  const [isAnimating, setIsAnimating] = useState(false);

  const pageKey = "motivation_7a";

  const { singleSelectionId, updateSingleSelection, handleNext } =
    useOnboardingPromotionPage({
      pageKey,
      nextPageRoute: `/${versionToPathPrefix(version)}-onboarding/motivation/8`,
    });

  const { trackSingleSelection } = usePromotionOnboardingTracking(
    pageKey,
    version
  );

  const handleOptionChange = (optionId: number) => {
    updateSingleSelection(optionId);
    trackSingleSelection(optionId);

    setTimeout(() => {
      setIsAnimating(false);
      handleNext({ singleSelectionId: optionId });
    }, 300);
  };

  return (
    <Stack spacing={5} sx={{ height: "100%" }}>
      <Stack spacing={2}>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{ color: theme.vars.palette.Content.Strong }}
        >
          {"내게는 지금 달성하고자 하는 목표가 있나요?"}
        </CustomTypography>
      </Stack>

      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <Stack
          direction={"column"}
          sx={{
            width: "100%",
            whiteSpace: "nowrap",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          {selectOptionList.map(({ id, label }) => (
            <Stack key={`select_option_${id}`} sx={{ flexGrow: 1, gap: 1 }}>
              <Button
                fullWidth
                variant={"SingleSlim"}
                size={"lg"}
                color={singleSelectionId === id ? "primary" : "secondary"}
                sx={{
                  transition: "background-color 0.3s ease",
                }}
                onClick={() => {
                  handleOptionChange(id);
                }}
              >
                {label}
              </Button>
            </Stack>
          ))}
        </Stack>
      </Box>
    </Stack>
  );
}
